import React from 'react';
import ConnectPage from '../components/ConnectPage';

const GA4ConnectPage: React.FC = () => {
  const config = {
    serviceName: 'Google Analytics',
    serviceDisplayName: 'Google Analytics',
    apiBaseUrl: 'https://api.ga4.plexhq.ai',
    routePath: '/connect/ga4',
    storageKeys: {
      email: 'userEmail',
      returnUrl: 'mcpReturnUrl',
      clientId: 'mcpClientId',
      state: 'mcpState',
      redirectUri: 'mcpRedirectUri',
      codeChallenge: 'mcpCodeChallenge',
    },
    messages: {
      requestAccess: 'Claude is requesting access to your Google Analytics data. Click "Connect" to authenticate.',
      directAccessError: 'This page is only accessible through Claude AI. Please add the Google Analytics connector in Claude to authenticate.',
      connectDescription: 'Connect your Google Analytics account to access your data through Claude AI.',
      connectingMessage: 'Connecting...',
      successMessage: 'Successfully connected to Google Analytics!',
      errorMessage: 'Failed to connect to Google Analytics. Please try again.',
      buttonText: 'Connect Your Google Analytics Account',
    },
  };

  return <ConnectPage config={config} />;
};

export default GA4ConnectPage;